import { Images } from "lucide-react";

/** A preview-only picture slot, sized by the image or feed card it stands in for. */
export function CanvasImage({
  attributes,
  setting,
}: {
  attributes: Record<string, unknown>;
  setting: string;
}) {
  return (
    <div
      {...attributes}
      className={`drate-page-node drate-page-image drate-page-image-placeholder ${attributes.className ?? ""}`}
      data-page-placeholder={setting}
      role="img"
      aria-label="Add image here"
    >
      <Images size={28} strokeWidth={1.5} aria-hidden="true" />
      <span>Add image here</span>
    </div>
  );
}
